import { ProjectStatus } from '../../types'
import { getStatusConfig } from '../../utils/projectStatus'

interface StatusBadgeProps {
  status: ProjectStatus
  className?: string
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const config = getStatusConfig(status)

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${config.bgColor} ${className}`}
    >
      {config.label}
    </span>
  )
}
